import axios from "./axios-config";


export const getWebisteData = async () => {
    let { data } = await axios.get(`/super-admin/setting-info`)
    return (data);
}

export const updateWebsiteInfo = async (websiteData) => {
    let { data } = await axios.put(`/super-admin/update-home`,websiteData)
    return (data);
}